export default __webpack_public_path__ + "static/media/icon-contacts-mail.1a3ebfba.svg";